export const CARDS = [
	{
		id: 1,
		title: 'Стать главным героем любимого фильма',
		type: 'in',
		text: 'Устроить костюмированную вечеринку',
		star: 'star1',
		gallery: 2,
		full:
			'Вестерн, боевик или комедия — выбирай любой жанр. Помимо фильма тебе понадобятся крутые костюмы напрокат и верные друзья. Можешь включить мюзикл и петь, разыгрывая фэнтези-сцены в собственной гостиной. Либо рассади всех поудобнее и смотри кино под веселые комментарии собравшихся. Чтобы #боржомить даже из дома выходить необязательно.',
	},
	{
		id: 2,
		title: 'Надеть пижамы',
		type: 'in',
		text: 'Устроить вечеринку с настольными играми',
		star: 'star2 medium right',
		gallery: 2,
		full:
			'Уютным выходным — быть! В морозный день, когда выходить на улицу нет никакого желания, можно пригласить близких насладиться домашним уютом в теплой компании. Освободи стол от праздничных блюд (к ним можно вернуться в любой момент) и разложи игры всех мастей. Чтобы #боржомить максимально атмосферно, попроси гостей прийти в пижамах и достань мягкие одеяла или вязаные пледы, в которые так и тянет укутаться. А если настольные игры наскучат, организуй чемпионат по боям подушками: он тоже отлично впишется в пижамную вечеринку.',
	},
	{
		id: 3,
		title: 'Изучить новые рецепты',
		type: 'in',
		text: 'Устроить кулинарный баттл с друзьями',
		star: 'star1 small right',
		gallery: 2,
		full:
			'Раздели собравшихся на две команды и объяви состязание, в котором заведомо победит дружба, — ведь битва окончится совместным ужином. Чтобы ограничить полет фантазии участников, задай тему: кухня определенной страны, рецепты именитого шеф-повара или фестиваль одного блюда — суши, бургеров, пиццы и так далее, вплоть до сэндвичей и брускетт. Если дома мало места, идите #боржомить в кулинарную студию. Там и мастер-класс организуют, и об ингредиентах позаботятся, и посуду мыть не заставят — сплошные плюсы!',
	},
	{
		id: 4,
		title: 'Настроиться на новогодний лад',
		type: 'in',
		text: 'Спеть «Jingle Bells» в караоке',
		gallery: 3,
		full:
			'Хорошо, если есть свитер с оленями для атмосферы и бодрая компания, которая будет размахивать бенгальскими огнями и подпевать. Ограничиваться одной песней необязательно: если уж #боржомить, то на полную. Можешь вспомнить и другие треки, которые помогают окунуться в атмосферу Нового года. «Пять минут», «Звенит январская вьюга» и «Снег кружится», «Happy New Year», «Last Christmas» и «Let It Snow», и многие другие — каждый найдет себе песню по душе.',
	},
	{
		id: 5,
		title: 'Нарядиться Дедом Морозом или Снегурочкой',
		type: 'in',
		text: 'Поздравить друзей',
		star: 'star2 medium',
		gallery: 3,
		full:
			'Высший пилотаж — наведываться в гости парой. Набей мешок символическими подарками, и пусть даже взрослые встают на стул, рассказывают стихи, водят хороводы и хором говорят: «Елочка, гори!» А ты будешь стучать посохом или хлопать в ладоши. Новый год — отличный повод почувствовать себя волшебником и помочь друзьям #боржомить, как в детстве.',
	},
	{
		id: 6,
		afisha: true,
		title: 'Морозным днем надеть шорты',
		type: 'out',
		text: 'Стать серфером',
		star: 'star1 right',
		gallery: 4,
		full:
			'Крытые серф-станции с искусственными волнами позволяют #боржомить на серфе в городе, где нет моря. Или где оно есть, но зимой слишком холодное. К тому же на симуляторе все гораздо удобнее и легче, чем на настоящем пляже. Во-первых, не надо ждать волну и тратить силы, чтобы подплыть к ней: вот она, прямо перед тобой. Во-вторых, волна небольшая и предсказуемая. В-третьих, она создана специально для тебя. Если ты давно мечтал покорять волны, но постоянно откладывал, — сейчас самое время. Кроме того, начав тренировки зимой, к пляжному сезону ты уже освоишь несколько крутых приемчиков.',
	},
	{
		id: 7,
		title: 'Создать музыкальный подарок',
		type: 'in',
		text: 'Поздравить любимого человека',
		gallery: 1,
		full:
			'Музыка так и манит тебя #боржомить, под каким бы соусом ты ее ни преподнес. Запиши песню на студии, сыграй на музыкальном инструменте, сведи треки на диджейских «вертушках» или пригласи музыкантов — можешь даже спеть под их аккомпанемент. Дозвониться в программу по заявкам на радио, передать привет и заказать вашу любимую на двоих песню — тоже отличный ход.',
	},
	{
		id: 8,
		afisha: true,
		title: 'Надеть футболку понаряднее',
		type: 'in',
		text: 'Освоить азы катания на горных лыжах',
		star: 'star2 right',
		gallery: 4,
		full:
			'И вы не ослышались! Все, что нужно, — найти место, где учат кататься в условиях искусственного снега. Дождитесь ясного солнечного дня и отправляйтесь #боржомить: сначала в пункт проката подбирать правильные лыжи, а затем — на искусственный склон осваивать стойку, технику езды и падения. Кататься в тепле в летней одежде — удивительное развлечение, когда за окном мороз.',
	},
	{
		id: 9,
		afisha: true,
		title: 'Взять в руки крыло',
		type: 'out',
		text: 'Погонять по ледяной реке на кайте',
		star: 'star1 small right',
		gallery: 4,
		full:
			'Воздушный змей тянет тебя вперед, а ты стоишь на доске и скользишь вслед за ним. Звучит почти как новогодняя сказка, и имя ей — сноукайтинг. Змей — собственно, кайт, а доска — обычный сноуборд, вместо которого можно использовать лыжи. Освоить базу сноукайтинга можно за несколько часов. Главное, не катайся в одиночку и убедись, что лед достаточно толстый. Если не уверен — отправляйся на заснеженное поле: там тоже удобно #боржомить на кайте.',
	},
	{
		id: 10,
		title: 'Стать крутым танцором',
		type: 'in',
		text: 'Поразить всех лихими движениями',
		gallery: 2,
		full:
			'Благодаря танцам ты всегда сможешь быть душой компании. Чтобы выступать в Большом, нужны годы тренировок, а стать звездой танцпола, овладев базовыми элементам, можно и за месяц. Но сначала лучше выбрать свое направление. Тот, кто хочет зажигательно отплясывать в паре, наверняка полюбит сальсу или меренгу. Если вы без ума от рэпа, битбокса и граффити, то проникнетесь и танцами в стиле хип-хоп. А хаус подойдет завсегдатаям ночных клубов и другим бодрым тусовщикам. Невероятная энергетика, которая вдохновляет свернуть горы, — вот главная причина #боржомить на танцполе.',
	},
	{
		id: 11,
		title: 'Собрать друзей',
		type: 'out',
		text: 'Соорудить арт-объект из снега',
		gallery: 2,
		full:
			'Построить замок принцессы, символ 2019 года свинью или обычного снеговика — за что бы вы ни взялись, в итоге все равно сможете провозгласить себя деятелями современного искусства. Или военными стратегами, — если построите крепость, а затем используете ее по назначению во время игры в снежки. Классно #боржомить можно и таким способом! Удачного штурма, лучших новогодних каникул и яркой зимы. Ура!',
	},
	{
		id: 12,
		title: 'Крепко зашнуровать коньки',
		type: 'out',
		text: 'Погонять с друзьями на катке',
		star: 'star1 right',
		gallery: 1,
		full:
			'Лед, пожалуй, главный зимний аттракцион, который притягивает людей всех возрастов. Надеемся, тебя он тоже манит, ведь каток — яркое место для активного отдыха компанией. Огни прожекторов, музыка, горячие напитки, ощущение всеобщего веселья — и ты с товарищами, готовые #боржомить на счет «три».',
	},
	{
		id: 13,
		title: 'Укутаться потеплее',
		type: 'out',
		text: 'скатиться с горы на тюбинге, санках или ледянке',
		star: 'star1',
		gallery: 2,
		full:
			'Катание с горки — одно из любимых развлечений детства. Когда ты последний раз несся кубарем с горы? В 7 лет? В 12? Вчера? Чем дольше перерыв, тем приятнее будет ностальгия и желание прокатиться еще раз, а потом еще (и еще). Новогодние каникулы — единственное время в году, когда всем вместе удается #боржомить по-детски. Предлагаем не упускать момент!',
	},
	{
		id: 14,
		afisha: true,
		title: 'Вооружиться щеткой ',
		type: 'in',
		text: 'Весело потереть лед в керлинге',
		star: 'star2 medium',
		gallery: 4,
		full:
			'Достойное применение навыка, отработанного во время предновогодней генуборки. Чтобы #боржомить с щеткой в руках, забронируй дорожку в керлинг-центре, надень теплые штаны, жилетку и перчатки, а остальное выдадут на месте. Там же за несколько минут расскажут правила. В игре участвуют две команды по 4 человека, то есть понадобятся 7 друзей и ты. Если ваша компания больше, остальные в это время могут болеть на трибунах или вести трансляции матча в соцсетях. Пусть все знают, как вам весело!',
	},
]

export default {
	CARDS,
}
